import { Descriptions, Space } from '@procurify/ui'

import { TextLoader } from '@webapp/core/components/ContentLoader'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export const ExpenseSummaryLoader = () => {
  const intl = useProcurifyIntl()

  return (
    <div aria-label={intl.formatMessage(messages.loadingLabel)}>
      <Space size='xlarge'>
        <Space>
          <Space direction='horizontal' align='center'>
            <TextLoader width={300} height={32} />
            <TextLoader width={80} height={24} />
          </Space>

          <Space direction='horizontal'>
            <Space.Item width={1 / 2}>
              <Descriptions columns={1}>
                <Descriptions.Item label={<TextLoader width={80} />}>
                  <TextLoader width={150} />
                </Descriptions.Item>
                <Descriptions.Item label={<TextLoader width={80} />}>
                  <TextLoader width={200} />
                </Descriptions.Item>
                <Descriptions.Item label={<TextLoader width={80} />}>
                  <TextLoader width={180} />
                </Descriptions.Item>
              </Descriptions>
            </Space.Item>

            <Space.Item width={1 / 2}>
              <Descriptions columns={1}>
                <Descriptions.Item label={<TextLoader width={80} />}>
                  <TextLoader width={150} />
                </Descriptions.Item>
                <Descriptions.Item label={<TextLoader width={80} />}>
                  <TextLoader width={150} />
                </Descriptions.Item>
                <Descriptions.Item label={<TextLoader width={80} />}>
                  <TextLoader width={200} />
                </Descriptions.Item>
              </Descriptions>
            </Space.Item>
          </Space>
        </Space>

        <Space>
          <TextLoader width={120} height={24} />
          <TextLoader width={400} height={16} />
        </Space>

        <Space>
          <TextLoader width='100%' height={40} />
          <TextLoader width='100%' height={36} />
          <TextLoader width='100%' height={36} />
          <TextLoader width='100%' height={36} />
        </Space>

        <Space direction='vertical' align='end'>
          <TextLoader width={300} height={20} />
          <TextLoader width={300} height={20} />
          <TextLoader width={300} height={24} />
          <TextLoader width={300} height={20} />
        </Space>
      </Space>
    </div>
  )
}

ExpenseSummaryLoader.displayName =
  'ExpenseSummaryLoader'
